import { inject, Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { MenuItem } from 'primeng/api';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class BreadcrumbService {
  private _breadcrumbs$ = new BehaviorSubject<MenuItem[]>([]);

  private title!: string;

  readonly breadcrumbs$: Observable<MenuItem[]> =
    this._breadcrumbs$.asObservable();

  private translocoService = inject(TranslocoService);

  private router = inject(Router);

  private route = inject(ActivatedRoute);

  constructor() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.title = '';
        this.buildBreadcrumbs();
      });
    this.translocoService.langChanges$.subscribe(() => {
      this.buildBreadcrumbs();
    });

    // this.buildBreadcrumbs();
  }

  private buildBreadcrumbs(): void {
    // Дождаться загрузки языка
    this.translocoService
      .load(this.translocoService.getActiveLang())
      .subscribe(() => {
        const breadcrumbs: MenuItem[] = [];

        let currentRoute = this.route.root;

        let url = '';

        // Get queryParams from the root route (they are the same for all route levels)
        const rootQueryParams = this.route.snapshot.queryParams;

        while (currentRoute.children.length > 0) {
          const child = currentRoute.children[0];

          const routeSnapshot = child.snapshot;

          if (routeSnapshot?.data?.['breadcrumb'] && routeSnapshot.url.length) {
            const path = routeSnapshot.url
              .map((segment) => segment.path)
              .join('/');
            url += '/' + path;

            const breadcrumbItem: MenuItem = {
              label: routeSnapshot.data['breadcrumb'],
              routerLink: url,
            };
            
            // Use root queryParams (they are the same for all route levels in Angular)
            if (Object.keys(rootQueryParams).length !== 0) {
              breadcrumbItem.queryParams = { ...rootQueryParams };
            }
            
            breadcrumbs.push(breadcrumbItem);
          }

          currentRoute = child;
        }

        this._breadcrumbs$.next(breadcrumbs);
        if (this.title) {
          this._breadcrumbs$.getValue().push({
            label: this.title,
            routerLink: '',
          });
        }
      });
  }

  addTitle(title: string) {
    this._breadcrumbs$.getValue().push({
      label: title,
      routerLink: '#',
    });

    this.title = title;
  }
}
